




































import {
    AccountTypeEnum,
    PartyModel,
    PartyPrintModel,
    PartyPrintTypeEnum,
    TenantModel,
    TenantUserModel
} from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { partiesStore } from '../+state/store';
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";
import {tenantsStore} from "@/libs/tenants/+state/store";

@Component({})
export default class General extends Page {

    @Prop() tenantId!: string;
    @Prop() partyId!: string;
    districtId: string | null = null;
    party: PartyModel | null = null;
    basicRules = [
        (v: any) => !!v || this.translate('validation.thisFieldIsRequired')
    ];
    deleteDialog = false;
    deleting = false;
    valid = false;
	printing = false;

    @Ref() form!: any;

    get saving(): boolean {
        return partiesStore.useGetter(CrudGetter.Saving);
    }

    get loading(): boolean {
        return partiesStore.useGetter(CrudGetter.Pending);
    }
    
    get readonly (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
        if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
            return true;
        }
        else if (tenantUser.accountType == AccountTypeEnum.Worker) {
            if (tenant.enableEditClientByWorker && this.party?.mainCareProviderId == tenantUser.userId) {
                return false;
            }
            else if (tenant.enableEditClientOfAnotherWorkers && this.party?.districtId == tenantUser.mainDistrictId) {
                return false;
            }
            else {
                return true;
            }
        }
        return false;
    }

    mounted () {
        this.party = partiesStore.useGetter(CrudGetter.Detail) as PartyModel;
    }

    save () {
        if (this.form.validate()) {
            partiesStore.dispatch(CrudAction.Update, { item: this.party });
        }
    }

	printClick(): void {
		this.printing = true;
		const printModel = {
			printType: PartyPrintTypeEnum.Interest
		} as PartyPrintModel;
		ApiService.api.printParty(this.partyId, printModel).then((x: any) => {
			this.printing = false;
			const res = x.data;
			const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.setAttribute('download', res.returnValue.filename!);
			document.body.appendChild(link);
			link.click();
			link.parentNode!.removeChild(link);
		}).catch(() => {
			this.printing = false;
		});
	}

}
